import React, { useCallback, useEffect } from 'react';
import { CardCarousel, Breakpoints, Action } from '@vw-marketing/us-components';
import { StyledTwitterCarouselContainer } from './styled';
import { useFeatureAppContent } from '../../hooks/use-feature-app-content';
import TweetCard from '../tweet-card';
import { useTrackingManager } from '../../services/use-tracking-manager';
import {
  onVWBasicLinkClickEvent,
  onVWBasicTwitterLoadEvent,
} from '../../tagging/tagging-helpers';

const TwitterCarousel = () => {
  const trackingManager = useTrackingManager();
  const { tweetsIds = [] } = useFeatureAppContent();

  const getTwitterAsset = () => tweetsIds.map((tweetId) => ({ tweetId }));

  useEffect(() => {
    onVWBasicTwitterLoadEvent(trackingManager, 'Twitter Carousel', {
      Type: 'Carousel',
      Name: 'Twitter Carousel',
      ItemCount: tweetsIds.length | 0,
      Asset: getTwitterAsset(),
    });
  }, []);

  const onHandleLinkTracking = useCallback(
    (type: Action, direction: string, position: number) => {
      const isNext = direction === 'next';
      const linkName = isNext ? 'Next' : 'Previous';

      type === 'click' &&
        onVWBasicLinkClickEvent(trackingManager, 'twitter carousel', {
          Type: 'Link',
          Name: linkName,
          ItemCount: tweetsIds.length | 0,
          ItemPosition: position,
          Asset: getTwitterAsset(),
        });
    },
    [],
  );

  return tweetsIds && tweetsIds?.length > 0 ? (
    <StyledTwitterCarouselContainer>
      <CardCarousel
        onActionTrackingTrigger={onHandleLinkTracking}
        visibleCards={4}
        visibleCardOnTablet={3}
        pageOffset
        desktopBreakpoint={Breakpoints.b1280}
        tabletBreakpoint={Breakpoints.b960}
      >
        {tweetsIds?.map((tweetId: string) => (
          <TweetCard tweetId={tweetId} key={tweetId} />
        ))}
      </CardCarousel>
    </StyledTwitterCarouselContainer>
  ) : (
    <></>
  );
};

export default TwitterCarousel;
